import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "jds_moreActions",
  "use": "jds_moreActions-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"jds_moreActions\">\n  <path fill-rule=\"evenodd\" d=\"M10.586 3.586a2 2 0 1 1 2.828 2.828 2 2 0 0 1-2.828-2.828Zm0 7a2 2 0 1 1 2.828 2.828 2 2 0 0 1-2.828-2.828Zm0 7a2 2 0 1 1 2.828 2.828 2 2 0 0 1-2.828-2.828Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol